import styled, { css } from 'styled-components';
import { media } from 'utils/media-query-helper';

const baseStyle = css`
  margin: 0;
  text-align: ${props => {
    if (props.center) {
      return 'center';
    }
    if (props.right) {
      return 'right';
    }
    return 'left';
  }};
  color: ${props => props.theme.colors.siteBlack};
  font-family: ${props => props.theme.fonts.montserratBold};
  max-width: 100%;
  transition: all 0.3s ease-in-out;
`;

export const HeaderOne = styled.h1`
  font-size: 1.6rem;
  ${baseStyle}
  ${media.tablet`font-size: 1.6rem;`}
  ${media.desktop`font-size: 1.6rem;`}
  ${media.wideScreen`font-size: 1.6rem;`}
  ${media.extraWideScreen`font-size: 1.6rem;`}
`;

export const HeaderTwo = styled.h2`
  font-size: 2rem;
  ${baseStyle}
  font-family: ${props => props.theme.fonts.montserratMedium};
  ${media.tablet`font-size: 2rem;`}
  ${media.desktop`font-size: 2rem;`}
  ${media.wideScreen`font-size: 2rem;`}
  ${media.extraWideScreen`font-size: 2rem;`}
`;

export const HeaderThree = styled.h3`
  font-size: 1.4rem;
  ${baseStyle}
  font-family: ${props => props.theme.fonts.montserratSemiBold};
  ${media.tablet`font-size: 1.4rem;`}
  ${media.desktop`font-size: 1.4rem;`}
  ${media.wideScreen`font-size: 1.4rem;`}
  ${media.extraWideScreen`font-size: 1.4rem;`}
`;

export const HeaderFour = styled.h4`
  font-size: 1.1rem;
  ${baseStyle}
  font-family: ${props => props.theme.fonts.montserratSemiBold};
  ${media.tablet`font-size: 1.1rem;`}
  ${media.desktop`font-size: 1.1rem;`}
  ${media.wideScreen`font-size: 1.1rem;`}
  ${media.extraWideScreen`font-size: 1.1rem;`}
`;

export const HeaderFive = styled.h5`
  font-size: 0.6rem;
  ${baseStyle}
  margin-bottom: 5px;
  ${media.tablet`font-size: 0.8rem;`}
  ${media.desktop`font-size: 1rem;`}
  ${media.wideScreen`font-size: 1.4rem;`}
  ${media.extraWideScreen`font-size: 1.8rem;`}
`;

export const HeaderSix = styled.h6`
  font-size: 0.4rem;
  ${baseStyle}
  margin-bottom: 5px;
  ${media.tablet`font-size: 0.7rem;`}
  ${media.desktop`font-size: .9rem;`}
  ${media.wideScreen`font-size: 1.2rem;`}
  ${media.extraWideScreen`font-size: 1.6rem;`}
`;
